export default "__VITE_ASSET__b0009dba__"